import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import * as AppPropTypes from '../../lib/PropTypes';

import RoundedButton from '../buttons/Rounded';
import Date from './Date';

import styles from '../../../styles/partials/event-box.module.scss';

const propTypes = {
    item: AppPropTypes.listItem,
    className: PropTypes.string,
    tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    withButton: PropTypes.bool,
};

const defaultProps = {
    item: null,
    className: null,
    tabIndex: null,
    withButton: false,
};

const EventBox = ({ item, className, withButton, tabIndex }) => {
    const { title = null, url = null, startDate = null, venue = null, film = null } = item || {};
    const { url: filmUrl = null } = film || {};
    const linkUrl = filmUrl !== null ? filmUrl : url;
    const isTitleLong = typeof title === 'string' && title.length > 40;

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                    [styles.isTitleLong]: isTitleLong,
                },
            ])}
        >
            <div className={styles.type}>
                <FormattedMessage defaultMessage="Event" description="Entity type heading" />
            </div>
            {title !== null ? <h3 className={styles.title}>{title}</h3> : null}
            {startDate !== null ? <Date date={startDate} className={styles.date} /> : null}
            {venue !== null && <div className={styles.venue}>{venue.name}</div>}
            {withButton && linkUrl !== null ? (
                <RoundedButton className={styles.button} href={linkUrl} tabIndex={tabIndex}>
                    <FormattedMessage
                        defaultMessage="More about this event"
                        description="Button label"
                    />
                </RoundedButton>
            ) : null}
        </div>
    );
};
EventBox.propTypes = propTypes;
EventBox.defaultProps = defaultProps;

export default EventBox;
